import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const PersonIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.46856 3.80538C3.46856 5.57376 5.02479 7.01285 6.93712 7.01285C8.84945 7.01285 10.4057 5.57376 10.4057 3.80538C10.4057 2.03699 8.84945 0.5979 6.93712 0.5979C5.02479 0.5979 3.46856 2.03699 3.46856 3.80538ZM13.1034 14.1406H13.8742V13.4278C13.8742 10.6772 11.4532 8.43839 8.4787 8.43839H5.39554C2.42028 8.43839 0 10.6772 0 13.4278V14.1406H13.1034Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default PersonIcon;

PersonIcon.propTypes = customIconsPropTypes;
